import React, { useEffect, useState } from "react";
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/HeaderTwo";
import ShopDetail from "../components/Refine/ShopDetail";
import FooterTwo from "../components/FooterTwo";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import { useParams } from "react-router-dom";
import axiosInstance from "../config/axios.config";
import { toast } from "react-toastify";
import { handleError } from "../utils/functions";

const ShopPage = () => {
  const { slug } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);
  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const { data } = await axiosInstance.get(`/seller/get/${slug}`);
        if (!data.error) {
          setData(data.data);
          console.log(data.data);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    };
    getData();
  }, [slug]);

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader isLoading={isLoading} />

      {/* HeaderOne */}
      <HeaderTwo category={true} />

      {/* ShopDetail */}
      <ShopDetail data={data} />

      {/* FooterTwo */}
      <FooterTwo />
    </>
  );
};

export default ShopPage;
